<template>
	<div id="receipts">
		<receipt-list-component></receipt-list-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import axiosAction from '@/mixins/axiosAction.js'
import errors from '@/mixins/errors.js'

import ReceiptListComponent from '@/components/ReceiptListComponent.vue'

export default {
	name: 'Receipts',
	mixins: [mixin, axiosAction, errors],
	data() {
		return {
		}
	},
	components: {
		'receipt-list-component': ReceiptListComponent
	},
	computed: {
	},
	methods: {
		axiosResultLocal(responseLocal, response) {
			switch (responseLocal) {
				case 'defaultFunction': this.defaultFunction(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')', this.$options.name); break;
			}
		},
		initModuleLocal() {
		}
	},
	mounted() {
		this.initModule(this.$options.name)
	},
}	
</script>

<style lang="scss"></style>
